import * as React from "react";
import {Box, useTheme} from "@mui/material";
import {observer} from "mobx-react";

function ArticlesOfFreeOrderConfirmationRequestComponent({children}) {
    const theme = useTheme();
    const style = styles(theme)

    return (
        <Box component="section" sx={style.formSectionContainer}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
            }}>
            </Box>
            {children}
        </Box>
    )
}

export default observer(ArticlesOfFreeOrderConfirmationRequestComponent)

const styles = (theme) => ({
    formSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'inherit',
        padding: '1rem',
        backgroundColor: theme.brand.field,
        borderRadius: '20px',
        marginBottom: '2rem',
    },
    formSectionTitle: {
        fontSize: '1rem',
        margin: '.8em 0'
    }
})